  export default function stringAvatar(name: string) {
    let newName = name;
    if (name.includes(' ')) {
      newName = `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`;
    }

    return {
      sx: {
        width: 30,
        height: 30,
        bgcolor: stringToColor(name),
      },
      children: newName,
    };
  }

    function stringToColor(string: string) {
    let hash = 0;
    let i;

    for (i = 0; i < string.length; i += 1) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = '#';

    for (i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.slice(-2);
    }

    return color;
  }